module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lSqqAv/tc-custom/9780795350757.jpg?1705292798339",
      "alt": "This image is the cover for the book Will of God"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Will of God\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The author of "), _c('i', [_vm._v("Make Me Like Jesus")]), _vm._v(" shares a personal and thought-provoking inquiry into the practical mechanics of knowing God’s will in our lives.")]), _c('br'), _c('br'), _vm._v("One of the greatest mysteries of the Christian faith is how we can understand the Will of God. The difficulty is underscored by Scripture’s repeated use of the word “unknowable” in connection with “the Almighty”. How can we possibly grasp that which is unknowable?"), _c('br'), _c('br'), _vm._v("Yet God commands us to know him. He also commands us to search diligently to find wisdom. We are therefore called upon to make the attempt to understand something we will never be capable of knowing. In Will of God, Michael Phillips discusses how we can best approach this challenge with gusto as well as humility.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Phillips\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0